if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  function registerXProductCart() {
    Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async hashProperties(formData) {
          let result = [];
          for (let [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) {
              if (value instanceof File) {
                result.push(`${value.name}:${value.size}:${value.type}`);
              } else {
                result.push(value);
              }
            }
          }
          result.push(formData.get('id'));
          result.sort();

          let data = result.join('|');

          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);

          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

          return hashHex;
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;         
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            await Alpine.store('xCartHelper').waitForEstimateUpdate();
            window.updatingEstimate = true;

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            const productFormEl = this.$refs.product_form
              || this.$el.closest('.mpb-v21__form')
              || this.$el.closest('form[data-type="add-to-cart-form"]')
              || this.$el.closest('form');
            if (!productFormEl) {
              console.error('Add to cart: product form not found');
              this.loading = false;
              return;
            }
            let formData = new FormData(productFormEl);
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${formData.get('product-id')}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(productFormEl);

            if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId && this.$refs.gift_wrapping_id) {              
              await this.hashProperties(formData).then(hashHex => {
                this.$refs.gift_wrapping_id.value = hashHex;
                formData = new FormData(productFormEl);
              });
            }

            let sellingPlanId = '';
            if (productFormEl) {
              if (typeof window.ngBuyBoxResolveSellingPlan === 'function') {
                sellingPlanId = window.ngBuyBoxResolveSellingPlan(productFormEl);
              } else if (typeof window.ngBuyBoxPrepareForAddToCart === 'function') {
                sellingPlanId = String(window.ngBuyBoxPrepareForAddToCart(productFormEl) || '').trim();
                productFormEl.dispatchEvent(new CustomEvent('ng:before-add-to-cart'));
              } else {
                productFormEl.dispatchEvent(new CustomEvent('ng:before-add-to-cart'));
              }
              formData = new FormData(productFormEl);
              if (!sellingPlanId) {
                sellingPlanId = String(formData.get('selling_plan') || '').trim();
              }
              if (!sellingPlanId && productFormEl.closest('.mpb-v21')) {
                const buyboxRoot = productFormEl.closest('.mpb-v21');
                const subscribeSelected = buyboxRoot?.querySelector('[data-bb-purchase][value="subscribe"]:checked')
                  || buyboxRoot?.querySelector('[data-bb-pcard="subscribe"].is-selected');
                if (subscribeSelected) {
                  sellingPlanId = String(
                    buyboxRoot?.querySelector('[data-bb-frequency]')?.value
                    || buyboxRoot?.querySelector('[data-bb-plan]')?.value
                    || ''
                  ).trim();
                }
              }
            }
            const sectionIds = Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id);
            const isBuybox = Boolean(productFormEl?.closest('.mpb-v21'));
            const cartAddJsonUrl = `${(window.Shopify?.routes?.root || '/')}cart/add.js`;
            let cartAddRequest;
            let cartAddUrl = Eurus.cart_add_url;

            let buyboxItem = null;
            if (isBuybox && productFormEl && typeof window.mpbV21ResolveCartLine === 'function') {
              buyboxItem = window.mpbV21ResolveCartLine(productFormEl);
            }
            if (!buyboxItem && isBuybox && typeof window.ngBuyBoxBuildCartAddItem === 'function') {
              buyboxItem = window.ngBuyBoxBuildCartAddItem(productFormEl);
            }

            if (buyboxItem && buyboxItem.selling_plan) {
              cartAddUrl = cartAddJsonUrl;
              cartAddRequest = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items: [{
                    id: Number(buyboxItem.id),
                    quantity: buyboxItem.quantity,
                    selling_plan: Number(buyboxItem.selling_plan)
                  }],
                  sections: sectionIds,
                  sections_url: window.location.pathname
                })
              };
            } else if (isBuybox && sellingPlanId) {
              const variantId = formData.get('id');
              const quantity = Number(formData.get('quantity') || 1);
              cartAddUrl = cartAddJsonUrl;
              cartAddRequest = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items: [{
                    id: Number(variantId),
                    quantity,
                    selling_plan: Number(sellingPlanId)
                  }],
                  sections: sectionIds,
                  sections_url: window.location.pathname
                })
              };
            } else if (isBuybox && buyboxItem) {
              cartAddUrl = cartAddJsonUrl;
              cartAddRequest = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items: [{
                    id: Number(buyboxItem.id),
                    quantity: buyboxItem.quantity
                  }],
                  sections: sectionIds,
                  sections_url: window.location.pathname
                })
              };
            } else {
              formData.append('sections', sectionIds);
              formData.append('sections_url', window.location.pathname);
              const newFormData = new FormData();
              for (let [key, value] of formData.entries()) {
                if (key === 'selling_plan') continue;
                if (value !== '') {
                  newFormData.append(key, value);
                }
              }
              if (sellingPlanId) {
                newFormData.set('selling_plan', sellingPlanId);
              }
              cartAddRequest = {
                method: 'POST',
                headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
                body: newFormData
              };
            }

            const updateCartSections = (cartResponse) => {
              const sections = cartResponse?.sections;
              if (!sections) {
                if (Alpine.store('xMiniCart')) Alpine.store('xMiniCart').reLoad();
                return;
              }
              Alpine.store('xCartHelper').getSectionsToRender().forEach((section) => {
                const sectionElement = document.querySelector(section.selector);
                if (sectionElement && sections[section.id]) {
                  sectionElement.innerHTML = getSectionInnerHTML(sections[section.id], section.selector);
                  reinitAlpineChildren(sectionElement);
                }
              });
            };

            await fetch(cartAddUrl, cartAddRequest).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.items && response.items[0]) {
                const merged = Object.assign({}, response.items[0]);
                if (response.sections) merged.sections = response.sections;
                response = merged;
              }
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                }
              } else {  
                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                let match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
                if (
                  (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
                  (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
                  (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === ''))
                ) {
                  let additionalOptionData = {
                    items: [],
                    sections:  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                  };
                  if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId && response.properties['_gift_wrapping_id']) {
                    additionalOptionData.items.push(
                      {
                        id: wrappringVariantId,
                        quantity: 1,
                        properties: {
                          "For": response.title,
                          "_key_link": response.properties['_gift_wrapping_id']
                        }
                      }
                    );
                  }
                  if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                    additionalOptionData.items.push(
                      {
                        id: engravingVariantId,
                        quantity: 1
                      }
                    );
                  }
                  if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved')) {
                    let match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
                    if (!match || match[1].trim() === '') {
                      additionalOptionData.items.push(
                        {
                          id: this.insuranceVariantId,
                          quantity: 1
                        }
                      );
                    }
                  }

                  if (additionalOptionData.items.length !== 0) {
                    await window.fetch('/cart/add.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                      },
                      body: JSON.stringify(additionalOptionData),
                    }).then((response) => {
                      return response.json();
                    }).then(response => {
                      document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                      this.error_message_wrapper = {};
        
                      if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                        Alpine.store('xQuickView').show = false;
                      }
                      if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                        Alpine.store('xPopup').close();
                      }
                      
                      if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                        document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                      } else {
                        updateCartSections(response);
                        if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                          Alpine.store('xMiniCart').openCart();
                          document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));  
                        }  
                        if (Alpine.store('xQuickView')) {
                          Alpine.store('xQuickView').openPopupMobile = false;
                        }
                        this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                        this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();

                        Alpine.store('xCartHelper').currentItemCount = parseInt((document.querySelector('#cart-icon-bubble span') || document.querySelector('.header-v21__cart-count'))?.textContent || '0', 10);
                        document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                      }
                    });  
                  }
                } else {
                  document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                  this.error_message_wrapper = {};
        
                  if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                    Alpine.store('xQuickView').show = false;
                  }
                  if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                    Alpine.store('xPopup').close();
                  }
                  
                  if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                    document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                  } else {
                    updateCartSections(response);
                    if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                      Alpine.store('xMiniCart').openCart();
                    }               
                    Alpine.store('xCartHelper').currentItemCount = parseInt((document.querySelector('#cart-icon-bubble span') || document.querySelector('.header-v21__cart-count'))?.textContent || '0', 10);
                    if (Alpine.store('xQuickView')) {
                      Alpine.store('xQuickView').openPopupMobile = false;
                    }
                    this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                    this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                    document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                    document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                  }
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              Alpine.store('xCartHelper').updateEstimateShippingFull();
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
                if(this.$refs.gift_wrapping_id) this.$refs.gift_wrapping_id.value = '';
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            })
          }, 0)
        }
      }))
  }

  document.addEventListener('alpine:init', registerXProductCart);
  document.addEventListener('alpine:initialized', registerXProductCart);
  if (window.Alpine) registerXProductCart();
}
